import { Component, EventEmitter, Input, OnInit, Output, ViewChildren, ViewChild, ElementRef, QueryList } from '@angular/core';
import { ModalTransferModel } from '../../../models/modal-transfer.model';
import { ListItemModel } from '../../../models/list-item.model';
import { PriceListItemModel, PriceListModel } from '../../../models/product/price-list/price-list.model';
import { ProductService } from '../../../services/product.service';
import { ConfigurationService } from '../../../services/configuration.service';
import swal from 'sweetalert2';
import { ExcelService, InternationalizationService } from '../../../services';
import * as XLSX from 'xlsx';
import { NgForm } from '@angular/forms';
import { PricelistAvailableProductsModalComponent } from '../pricelist-available-products-modal/pricelist-available-products-modal.component';


@Component({
    selector: 'app-price-list-edit-modal',
    templateUrl: './price-list-edit-modal.component.html',
    styleUrls: ['./price-list-edit-modal.component.scss']
})

export class PriceListEditModalComponent implements OnInit {
    @Input() name: string;
    @Input() id: number;
    @Input() reference: ModalTransferModel;

    model: PriceListModel;
    selectedNav = 1;
    title: string;
    currencyOptions: Array<ListItemModel> = [];
    auxid: string;
    auxNumba: string;

    products: Array<any> = [];
    addOns: Array<PriceListItemModel> = [];

    @Input() set open(open: boolean) {
        this._open = open;
    }
    get open(): boolean {
        return this._open;
    }
    private _open: boolean;

    @Output() modalClose = new EventEmitter();
    @ViewChildren('inputPrice') inputPrice: QueryList<HTMLInputElement>;
    @ViewChildren('th1') titles: QueryList<HTMLInputElement>;
    @ViewChild('file') file!: ElementRef;

    openPriceListAvailable: boolean;
    modalReference: ModalTransferModel;
    loading: boolean;

    // Column order the export/template uses; also the contract the import expects.
    private static readonly IMPORT_HEADERS = ['Id', 'PriceListId', 'ProductVersionId',
        'PriceSheetName', 'Name', 'Sku', 'VersionName', 'PriceCode', 'CostCode', 'Cost', 'Margin', 'Price', 'DiscountPrice', 'IsActive'];
    // Ids whose prices changed in the last import, used to highlight rows after reload.
    importedChangedIds: Set<string> = null;

    constructor(private readonly prodSrv: ProductService,
        private readonly confSrv: ConfigurationService, private readonly excelSvc: ExcelService, private readonly i18Svc: InternationalizationService
        , private readonly exportService: ExcelService
    ) {
        this.i18Svc.initialize();
    }

    ngOnInit(): void {
        this.getCurrencies();
        this.initAction();
    }
    initAction() {
        if (this.reference.action === 'copy') {
            this.model = PriceListModel.Cast(this.reference.object);
            this.model.Name = `${this.model.Name}-Copy`;
            this.title = `Cloning ${this.model.Name}`;
            this.getPriceListItems(this.model.Id);
            this.model.Id = 0;
        } else if (this.reference.action === 'new') {
            this.model = PriceListModel.Create();
            this.title = 'New Price List';
            this.setDefaultCurrency();
            this.getPriceListAvailableItems();
        } else if (this.reference.action === 'edit') {
            this.model = PriceListModel.Cast(this.reference.object);
            this.title = `Edit ${this.model.Name} (${this.model.Id})`;
            this.getPriceListItems(this.model.Id);
        }
    }
    setDefaultCurrency() {
        if (!this.reference.object && this.currencyOptions.length > 0 && this.model) {
            this.model.CurrencyId = this.currencyOptions[0].id;
            this.model.Currency = this.currencyOptions[0].value;
        }
    }
    getCurrencies() {
        this.confSrv.getCurrencyOptions().subscribe(
            data => { this.onGetCurrencies(data) },
            err => this.onError(err));
    }
    onGetCurrencies(data) {
        if (data['result']) {
            this.currencyOptions = [];
            data['result'].forEach(x =>
                this.currencyOptions.push(ListItemModel.Parse(x)));
        }
        this.setDefaultCurrency();
    }
    getPriceListAvailableItems() {
        this.prodSrv.getPriceListAvailableItems().subscribe(
            data => this.onGetPriceListItems(data),
            err => this.onError(err));
    }
    getPriceListItems(id: number) {
        this.prodSrv.getPriceListItems(id).subscribe(
            data => this.onGetPriceListItems(data),
            err => this.onError(err));
    }
    updatePriceListItems() {
        if (this.products.length > 0) {
            this.prodSrv.updatePriceListItems(this.products.concat(this.addOns)).subscribe(
                data => this.onGetPriceListItems(data),
                err => this.onError(err));
        }
    }
    getAvailProductVersionItems(id: number) {
        this.prodSrv.getProductVersionAvailableItems(id).subscribe(
            data => this.onGetPriceListItems(data),
            err => this.onError(err));
    }
    onGetPriceListItems(data) {
        if (data['result']) {
            this.products = [];
            this.addOns = [];
            data['result'].forEach(x => {
                if (x) {
                    this.splitProds(PriceListItemModel.Parse(x));
                }
            });
        }
        // Highlights only apply to the reload that immediately follows an import.
        this.importedChangedIds = null;
    }
    splitProds(model: PriceListItemModel) {
        if (model.ProductVersionId) {
            const mod = { ...model, percent: this.getPercent(model.Price, model.DiscountPrice), hasError: false, isTouched: false, imported: this.importedChangedIds?.has(String(model.Id)) || false }
            this.products.push(mod)
        } else if (model.ProductAddOnId) {
            this.addOns.push(model);
        }
    }
    onError(err) {
        this.loading = false;
        swal({
            position: 'top-end',
            type: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
            footer: '<a href>Why do I have this issue?</a>'
        });
    }

    // Modal General UI Controls
    validModel(): boolean {
        return this.model.IsValid();
    }
    close() {
        this.open = false;
        this.modalClose.emit(true);
    }
    save() {
        if (this.validModel()) {
            this.loading = true;
            if (this.reference.action === 'edit') {
                this.prodSrv.updatePriceList(this.model)
                    .subscribe(data => this.onEdit(data),
                        err => this.onError(err));
                this.updatePriceListItems();
            } else {
                this.prodSrv.createPriceList(this.model)
                    .subscribe(data => this.onCreate(data),
                        err => this.onError(err));
            }
        }
    }
    onEdit(data): boolean {
        this.loading = false;
        if (data['result']) {
            this.reference.action = 'edit';
            this.reference.object = PriceListModel.Parse(data['result']);
            this.model.Id = this.reference.object.Id;
            this.initAction();
            swal({
                position: 'top-end',
                type: 'success',
                title: 'Price list have been save',
                showConfirmButton: false,
                timer: 1500
            });
            return true;
        } else {
            swal({
                position: 'top-end',
                type: 'error',
                title: 'Oops...',
                text: data['errorMessage'],
                footer: '<a href>Why do I have this issue?</a>'
            });
            return false;
        }
    }
    onCreate(data) {
        this.loading = false;
        if (this.onEdit(data)) {
            this.products.forEach(x => {
                x.PriceListId = this.model.Id
                x.Id = 0
            });
            this.addOns.forEach(x => x.PriceListId = this.model.Id);
            this.updatePriceListItems();
            if (this.reference.action === 'copy') {
                this.reference.action = 'edit';
                this.title = `Edit ${this.model.Name} (${this.model.Id})`;
            }
        }
    }

    onExport(): void {
        if (this.products.length > 0) {
            let arrObj = [];
            this.products.forEach((e: PriceListItemModel) => {
                const { Id, PriceListId, ProductVersionId, PriceSheetName, Name, Sku, VersionName, PriceCode, CostCode, Cost, Margin, Price, DiscountPrice, IsActive

                } = { ...e }
                const obj = { Id, PriceListId, ProductVersionId, PriceSheetName, Name, Sku, VersionName, PriceCode, CostCode, Cost, Margin, Price, DiscountPrice, IsActive
                }
                arrObj.push(obj);
            });

            this.excelSvc.exportAsExcelFile(arrObj, 'PriceList');
        }
    }

    onImport(evt: any): void {
        const input = evt.target;
        const target: DataTransfer = <DataTransfer>(evt.target);
        if (!target.files || target.files.length !== 1) { return; }
        const fileObj: File = target.files[0];

        // A price list must exist (be saved) before prices can be imported into it.
        if (!this.model.Id) {
            input.value = null;
            this.importNotify('pricelist.import.save_first', 'info');
            return;
        }

        // Only accept the exported spreadsheet format.
        const fileName = (fileObj.name || '').toLowerCase();
        if (!fileName.endsWith('.xlsx') && !fileName.endsWith('.xls')) {
            input.value = null;
            this.importNotify('pricelist.import.invalid_file', 'error');
            return;
        }

        const reader: FileReader = new FileReader();
        reader.onerror = () => { input.value = null; this.importNotify('pricelist.import.parse_error', 'error'); };
        reader.onload = (e: any) => {
            input.value = null;
            let dataUpload: any[];
            try {
                const wb: XLSX.WorkBook = XLSX.read(e.target.result, { type: 'binary' });
                const ws: XLSX.WorkSheet = wb.Sheets[wb.SheetNames[0]];
                dataUpload = <any[]>(XLSX.utils.sheet_to_json(ws, { header: PriceListEditModalComponent.IMPORT_HEADERS }));
            } catch {
                this.importNotify('pricelist.import.parse_error', 'error');
                return;
            }

            // Row 0 holds the file's header labels; reject anything that isn't the template.
            if (!dataUpload || dataUpload.length < 2 || !this.isValidTemplate(dataUpload[0])) {
                this.importNotify('pricelist.import.invalid_template', 'error');
                return;
            }

            const currentById = new Map<string, any>(this.products.map(p => [String(p.Id), p]));
            const parseData: Array<PriceListItemModel> = [];
            const changedIds = new Set<string>();
            let matched = 0;
            for (let i = 1; i < dataUpload.length; i++) {
                const row = dataUpload[i];
                if (row['Id'] === undefined || row['Id'] === null || row['Id'] === '') { continue; }
                parseData.push(new PriceListItemModel(row['Id'], this.model.Id, row['ProductVersionId'],
                    row['ProductAddOnId'], row['Name'], row['Sku'], row['VersionName'],
                    row['PriceCode'], row['CostCode'], row['Price'],
                    row['DiscountPrice'], row['IsActive'], row['Cost']));
                const current = currentById.get(String(row['Id']));
                if (current) {
                    matched++;
                    if (this.priceRowChanged(current, row)) { changedIds.add(String(row['Id'])); }
                }
            }

            if (parseData.length === 0) {
                this.importNotify('pricelist.import.empty', 'warning');
                return;
            }
            // None of the uploaded rows belong to this price list -> wrong sheet.
            if (this.products.length > 0 && matched === 0) {
                this.importNotify('pricelist.import.wrong_sheet', 'error');
                return;
            }
            // The sheet matches but nothing was actually edited.
            if (this.products.length > 0 && changedIds.size === 0) {
                this.importNotify('pricelist.import.no_changes', 'info');
                return;
            }

            this.importedChangedIds = changedIds;
            this.loading = true;
            this.prodSrv.updatePriceListItems(parseData).subscribe(
                data => this.onImportSuccess(data, changedIds.size),
                err => this.onError(err));
        };
        reader.readAsBinaryString(fileObj);
    }

    onImportSuccess(data: any, changedCount: number): void {
        this.loading = false;
        if (data && data['result']) {
            this.getPriceListItems(this.model.Id);
            swal({
                position: 'top-end',
                type: 'success',
                title: `${changedCount} ${this.i18Svc.getTranslateVal('pricelist.import.prices_updated')}`,
                showConfirmButton: false,
                timer: 2500
            });
        } else {
            this.importedChangedIds = null;
            this.importNotify('pricelist.import.failed', 'error', data && data['errorMessage']);
        }
    }

    // Validates the header row produced by sheet_to_json (its values are the file's column labels).
    isValidTemplate(headerRow: any): boolean {
        return headerRow
            && headerRow['Id'] === 'Id'
            && headerRow['Price'] === 'Price'
            && headerRow['DiscountPrice'] === 'DiscountPrice';
    }

    // True when an uploaded row differs from the currently loaded price for that item.
    priceRowChanged(current: any, row: any): boolean {
        return Number(current.Price) !== Number(row['Price'])
            || Number(current.DiscountPrice) !== Number(row['DiscountPrice'])
            || Number(current.Cost) !== Number(row['Cost'])
            || !!current.IsActive !== !!row['IsActive'];
    }

    private importNotify(key: string, type: 'success' | 'error' | 'warning' | 'info', detail?: string): void {
        swal({
            position: 'top-end',
            type,
            title: this.i18Svc.getTranslateVal(key),
            text: detail || undefined,
            showConfirmButton: type === 'error',
            timer: type === 'error' ? undefined : 2500
        });
    }

    highlightPChange(form: NgForm, i): string {
        return form.form.controls[`Price${i}`]?.dirty ? 'change-highlight' : 'mat-input';
    }

    highlightDPChange(form: NgForm, i): string {
        return form.form.controls[`DiscountPrice${i}`]?.dirty ? 'change-highlight' : 'mat-input';
    }

    onViewMore(): void {
        this.openPriceListAvailable = true;
        this.modalReference = new ModalTransferModel('edit', PricelistAvailableProductsModalComponent, this.model.Id, null, null);
    }

    onClosePriceListAvailableModal(data) {
        this.openPriceListAvailable = false;
        if (data) {
            this.products.push(...data);
        }
    }

    getPercent(price: number = 0, discountPrice: number = 0) {

        if (price === 0) {
            return 0;
        } else if (discountPrice === 0) {
            return 0
        } else {
            return ((discountPrice / price))
        }
    }
    editParams(obj: any, type: string, event: any) {
        let regex = /[$ € % ?]+/;
        let regex2 = /[, . .0 .00 ?]+/;
        let value = event.target.value;
        if (value.length === 0 || value === undefined) {
            value = 0;
        }
        obj.hasError = false;
        switch (type) {
            case 'price':
                if (regex.test(value)) {
                    value = value.replace(/([ $ € ])/g, '');
                }
                if (regex2.test(value)) {
                    value = value.replace(/([/,/g])/g, '');
                }
                if (this.getPercent(value, obj.DiscountPrice) < 0) {
                    obj.percent = 0
                } else if (value < obj.DiscountPrice) {
                    obj.hasError = true;
                    return;
                } else {
                    obj.percent = Number(this.getPercent(value, obj.DiscountPrice));
                }

                break;
            case 'discount':
                if (regex.test(value)) {
                    value = value.replace(/([ $ € ])/g, '');
                }
                if (regex2.test(value)) {
                    value = value.replace(/([/,/g])/g, '');
                }
                obj.Price = Number(value / (obj.percent));
                break;
            case 'percent':
                if (event.target.value > 0) {
                    obj.Price = Number(obj.DiscountPrice / ((event.target.value) / 100))
                } else {
                    obj.price = Number(obj.DiscountPrice);
                }

                break;

            default:
                break;
        }

    }
    onFocusOutEvent(event: any, obj: any, type: string) {
        let regex = /[$ € % ?]+/;
        let regex2 = /[, . .0 .00 ?]+/;
        let value = event.target.value;
        if (value.length === 0 || value === undefined) {
            value = 0;
        }
        switch (type) {
            case 'price':
                if (regex.test(value)) {
                    value = value.replace(/([ $ € ])/g, '');
                }
                if (regex2.test(value)) {
                    value = value.replace(/([/,/g])/g, '');
                }
                if (value < obj.DiscountPrice) {
                    value = Number(obj.DiscountPrice);
                    obj.percent = 100;
                    obj.hasError = false;
                }
                obj.Price = Number(value);
                break;
            case 'discount':
                if (regex.test(value)) {
                    value = value.substring(1, value.length)
                }
                obj.DiscountPrice = Number(value);
                break;
            case 'percent':
                if (regex.test(value)) {
                    value = value.substring(0, value.length - 1)
                    obj.percent = Number(value / 100);
                } else {
                    obj.percent = Number(value / 100);
                }

                break;

            default:
                break;
        }
    }

    createReport(event: any, obj: any) {
        if (event.target.value == 2) {
            let arrTitles = ['Id','PriceListId','ProductVersionId','PriceSheetName','Name','Sku','VersionName','PriceCode','CostCode','Cost','Margin','Price','DiscountPrice','IsActive'];
            let arrObj = [];
            this.exportService.exportDocument('xls', arrObj, arrTitles,'PriceList_Upload_Template_');
        }
        else if (event.target.value == 1) {
            this.file.nativeElement.click();
        }
    }
    
}
